const comments = [
  {
    name: '追综达人小林',
    role: '综艺深度爱好者',
    text: '画质清晰流畅，终于找到能好好看综艺的地方了！之前在其他平台老是卡顿缓冲，51影视的播放体验真的太好了，1080P看《奔跑吧》每一帧都清清楚楚。',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20portrait%20style%20circular%20avatar%20with%20soft%20amber%20glow%20background%2C%20abstract%20minimalist%20face%20silhouette%2C%20friendly%20vibe%2C%20warm%20orange%20gradient%20tones%2C%20simple%20clean%20design&width=80&height=80&seq=comment-avatar-01&orientation=squarish',
  },
  {
    name: '综艺迷阿杰',
    role: '三年老用户',
    text: '更新速度超快，每次新一期出来这里就能看，太方便了。不用会员就能看全集，这在现在的平台里真的太难得了。已经把51影视推荐给身边所有朋友了！',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20portrait%20style%20circular%20avatar%20with%20soft%20coral%20glow%20background%2C%20abstract%20minimalist%20face%20silhouette%2C%20friendly%20vibe%2C%20warm%20pink%20gradient%20tones%2C%20simple%20clean%20design&width=80&height=80&seq=comment-avatar-02&orientation=squarish',
  },
  {
    name: '影视爱好者小美',
    role: '每日追更新',
    text: '资源太全了！从户外真人秀到音乐竞演，从脱口秀到推理探案，想看的综艺这里全都有。而且完全免费，真的是良心平台，强烈推荐给所有综艺爱好者！',
    avatar: 'https://readdy.ai/api/search-image?query=A%20warm%20portrait%20style%20circular%20avatar%20with%20soft%20golden%20glow%20background%2C%20abstract%20minimalist%20face%20silhouette%2C%20friendly%20vibe%2C%20warm%20yellow%20gradient%20tones%2C%20simple%20clean%20design&width=80&height=80&seq=comment-avatar-03&orientation=squarish',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 lg:px-8">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="inline-block px-4 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold mb-4 whitespace-nowrap">
              用户评价
            </span>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-black text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
              综艺爱好者们都在说
            </h2>
            <p className="text-foreground-500 text-sm md:text-base mt-3 max-w-2xl mx-auto">
              听听真实用户对51影视的评价，你的追综伙伴已经在这里
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {comments.map((comment) => (
              <div
                key={comment.name}
                className="bg-background-50 border border-background-200 rounded-2xl p-6 md:p-7 hover:border-secondary-300 transition-all"
              >
                <div className="flex items-center gap-3 mb-4">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-12 h-12 rounded-full object-cover"
                    loading="lazy"
                  />
                  <div>
                    <div className="text-sm font-bold text-foreground-900">{comment.name}</div>
                    <div className="text-xs text-foreground-500">{comment.role}</div>
                  </div>
                </div>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  &ldquo;{comment.text}&rdquo;
                </p>
                <div className="flex items-center gap-1 mt-4">
                  {[...Array(5)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-accent-400 text-sm"></i>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}